import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const MainLayout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);
      if (!mobile) setShowMobileSidebar(false);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) {
      setShowMobileSidebar(!showMobileSidebar);
    } else {
      setIsCollapsed(!isCollapsed);
    }
  };

  return (
    <div className="min-vh-100 bg-dark text-white overflow-hidden">
      {/* Sidebar Overlay for Mobile */}
      {isMobile && showMobileSidebar && (
        <div 
          className="position-fixed vh-100 vw-100 top-0 start-0 bg-black bg-opacity-50"
          style={{ zIndex: 1040 }}
          onClick={() => setShowMobileSidebar(false)}
        />
      )}

      <Sidebar 
        isCollapsed={isMobile ? !showMobileSidebar : isCollapsed} 
        setIsCollapsed={toggleSidebar}
        isMobile={isMobile}
      />
      
      <div 
        className="main-content"
        style={{ 
          marginLeft: isMobile ? '0' : (isCollapsed ? 'var(--sidebar-collapsed-width)' : 'var(--sidebar-width)'),
          transition: 'margin-left 0.3s ease'
        }}
      >
        <Navbar 
          isCollapsed={isCollapsed} 
          isMobile={isMobile} 
          toggleSidebar={toggleSidebar} 
        />
        <main className="p-3 p-md-4">
          {children}
        </main>
      </div>

      <style jsx="true">{`
        .main-content {
          min-height: 100vh;
          background-color: var(--bg-color);
          width: isMobile ? '100%' : 'auto';
        }
      `}</style>
    </div>
  );
};

export default MainLayout;
